import React from 'react';
import { Link } from 'react-router-dom';

const StatCard = ({ title, value, icon, color, link }) => {
  const getColorClass = (color) => {
    switch (color) {
      case 'primary':
        return 'bg-primary text-white';
      case 'success':
        return 'bg-success text-white';
      case 'info':
        return 'bg-info text-white';
      case 'warning':
        return 'bg-warning text-white';
      case 'danger':
        return 'bg-danger text-white';
      default:
        return 'bg-primary text-white';
    }
  };

  const CardContent = () => (
    <div className={`card ${getColorClass(color)} h-100`}>
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h6 className="card-title mb-1">{title}</h6>
            <h3 className="mb-0">{value.toLocaleString()}</h3>
          </div>
          <div className="text-end">
            <i className={`${icon} fa-2x opacity-75`}></i>
          </div>
        </div>
      </div>
    </div>
  );

  if (link) {
    return (
      <Link to={link} className="text-decoration-none">
        <CardContent />
      </Link>
    );
  }

  return <CardContent />;
};

export default StatCard; 